import moment from 'moment'

moment.locale('es-mx')

// eslint-disable-next-line func-names
export default function (date, isUtc = true, removeTime = false) {
  let format = 'DD/MMM/YYYY HH:mm'
  if (removeTime) {
    format = 'DD/MMM/YYYY'
  }
  if (!date || date === new Date(8640000000000000)) {
    return null
  }

  if (isUtc) {
    return moment.utc(date).local().format(format)
  }

  return moment(date).format(format)
}
